import { GERMAN_WEEKDAYS } from '../../../shared/lib/timeline/weekHelpers'

interface Props {
  weekDays: string[]
}

export const WeekHeader = ({ weekDays }: Props) => (
  <div className="w-full flex items-center">
    <div className="w-56 shrink-0 h-11 px-3.5 py-3 bg-white outline outline-1 outline-offset-[-0.50px] outline-slate-200 flex items-center sticky left-0 z-10">
      <span className="text-gray-400 text-base font-medium font-['Inter']">Handwerkern</span>
    </div>
    <div className="flex-1 grid grid-cols-5 min-w-0">
      {weekDays.map((dayKey, i) => {
        const dayNum = new Date(dayKey + 'T00:00:00').getDate()
        const today = new Date()
        const isToday =
          today.getFullYear() === new Date(dayKey + 'T00:00:00').getFullYear() &&
          today.getMonth() === new Date(dayKey + 'T00:00:00').getMonth() &&
          today.getDate() === dayNum

        return (
          <div
            key={dayKey}
            className={`h-11 p-3 bg-white outline outline-1 outline-offset-[-0.50px] outline-slate-200 flex items-center gap-1.5 ${
              isToday ? 'bg-blue-50' : ''
            }`}
          >
            <span className="text-gray-400 text-sm font-medium font-['Inter']">
              {GERMAN_WEEKDAYS[i]}
            </span>
            <span className={`text-sm font-medium font-['Inter'] ${isToday ? 'text-[#004494]' : 'text-gray-400'}`}>
              {dayNum}
            </span>
          </div>
        )
      })}
    </div>
  </div>
)
